module.exports = __webpack_public_path__ + "img/cooperative_banner.b815a9f8.jpg";